import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api from "../services/api";
import Toast from "../components/toast";

export default function Wallet() {
    const { isAuthenticated, accessToken, loading: loadingauth } = useAuth();
    const navigate = useNavigate();

    const FULL_CARD_NUMBER = "1234 1234 1234 1234";

    const [walletBalance, setWalletBalance] = useState('0');
    const [loading, setLoading] = useState(true);

    const [name, setName] = useState('');
    const [payAmount, setPayAmount] = useState('');
    const [customercardnumber, setCustomercardnumber] = useState('');
    const [description, setDescription] = useState('');

    const [Error, setError] = useState("");
    const [isPaying, setIsPaying] = useState(false);

    const [toast, setToast] = useState<{ title: string, text: string }>();
    const [toastshow, setToastshow] = useState(false);

    const fetchwalletBalance = async () => {
        try {
            const mainRes = await api.get("/wallet/balance", {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (mainRes.data?.balance) {
                setWalletBalance(mainRes.data.balance);
            }

        } catch (err) {
            console.log("cart fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (loadingauth) return;

        if (!isAuthenticated) {
            navigate('/');
            return;
        }

        fetchwalletBalance();

    }, [isAuthenticated, loadingauth]);

    const validateNumber = (value: string) => {
        const regex = /^09[0-9]{9}$/;

        if (/[^0-9]/.test(value)) {
            setError("Only digits allowed");
            return false;
        }

        setError("");
        return true;
    };

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (isPaying) return;
        if (!validateNumber(payAmount) || !validateNumber(customercardnumber)) {
            setError("مبلغ و شماره کارت باید عدد و پشت سرهم باشند.");
            return;
        }
        setIsPaying(true);
        try {
            const Res = await api.post("/wallet/topup", {
                amount: Number(payAmount),
                description: `نام و نام خانوادگی : ${name} | مبلغ : ${payAmount} | شماره کارت مبدا : ${customercardnumber} | توضیحات بیشتر : ${description}`
            }, {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (Res.status === 200) {
                setToastshow(true);
                setToast({ title: 'موفقیت', text: "با موفقیت درخواست شما به ادمین ارسال شد." });
                setIsPaying(false);
            }
        } catch (err) {
            console.log("cart update error:", err);
        }
    };

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            return false;
        }
    };

    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        const ok = await copyToClipboard(FULL_CARD_NUMBER);
        if (ok) {
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        }
    };

    return (
        <div dir="rtl" className="min-h-screen bg-darkbg text-white flex justify-center px-5 py-6 ">
            <div className="max-w-[420px] overflow-hidden px-4 w-full flex flex-col justify-center animate-fadeIn">
                <h2 className="text-center text-primary text-xl mb-5">افزایش موجودی کیف پول</h2>

                <div className="relative bg-[rgba(105,100,100,0.55)] border-2 border-primary p-4 rounded-2xl mb-5 text-center">
                    <p className="text-[20px] font-bold">{(FULL_CARD_NUMBER)}</p>

                    <div onClick={handleCopy}
                        className="absolute top-[30%] left-[6%] w-6 h-6 flex items-center justify-center cursor-pointer active:scale-90"
                    >
                        {!copied ? (
                            <svg height="23" width="23" viewBox="0 0 24 24" fill="#f4b400">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3
                                    4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2
                                    2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0
                                    16H8V7h11v14z"/>
                            </svg>
                        ) : (
                            <svg height="23" width="23" viewBox="0 0 24 24" fill="#00e676">
                                <path d="M9 16.2l-3.5-3.5L4 14.2l5 5 12-12-1.5-1.5z" />
                            </svg>
                        )}
                    </div>
                </div>
                <p className="text-center text-[13px] text-[#f4f4f4]/70 mb-6">پس از انجام تراکنش به شماره کارت بالا ، اطلاعات زیر را تکمیل فرمایید.</p>
                <form onSubmit={handleSubmit} className="flex flex-col">
                    <label className="text-[15px] text-[#e8e8e8]">نام و نام خانوادگی</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="bg-white/10 border border-white/20 rounded-xl px-3 py-2 mb-3 text-gray-300"
                    />

                    <label className="text-[15px] text-[#e8e8e8]">مبلغ</label>
                    <input
                        type="text"
                        value={payAmount}
                        onChange={(e) => setPayAmount(e.target.value)}
                        required
                        className="bg-white/10 border border-white/20 rounded-xl px-3 py-2 mb-3 text-gray-300"
                    />
                    <label className="text-[15px] text-[#e8e8e8]">شماره کارت مبدا (شما)</label>
                    <input
                        type="text"
                        value={customercardnumber}
                        onChange={(e) => setCustomercardnumber(e.target.value)}
                        required
                        className="bg-white/10 border border-white/20 rounded-xl px-3 py-2 mb-3 text-gray-300"
                    />
                    <label className="text-[15px] text-[#e8e8e8]">کد پیگیری / مشخصات</label>
                    <textarea
                        required
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="کد پیگیری، زمان تراکنش..."
                        className="bg-white/10 border border-white/20 rounded-xl px-3 py-3 h-24 resize-none mb-4 text-gray-300"
                    />

                    <div className="text-red-400 text-xs mt-1">{Error}</div>
                    <div className="flex justify-between gap-4">
                        <button type="submit"
                            className={`w-1/2 py-3 rounded-xl text-black font-bold transition-all
                            ${isPaying ? "bg-primary/50 scale-95" : "bg-primary active:scale-95"}`}
                        >{isPaying ? "در حال پردازش..." : "ثبت اطلاعات تراکنش"}</button>

                        <button type="button"
                            onClick={() => navigate("/profile")}
                            className="w-1/2 py-3 bg-white/20 text-white rounded-xl"
                        >انصراف</button>
                    </div>

                    <div className="text-center text-[#d6b25e] mt-5 text-[16px]">
                        موجودی فعلی :
                        <span className="text-[#f4c430] text-lg font-bold mx-1">
                            {Number(walletBalance).toLocaleString()}
                        </span>
                        تومان
                    </div>
                </form>

                <Toast active={toastshow} title={toast?.title} text={toast?.text} setToastshow={setToastshow} />
            </div>
        </div>
    );
}